(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results-common/assets/javascripts/helpers/peppbubbles.js') >= 0) return;  svs.modules.push('/components/numbergames/results-common/assets/javascripts/helpers/peppbubbles.js');

'use strict';

const createBubble = rows => {
  const paragraph = document.createElement('p');
  paragraph.classList.add('ng-peppbubble');
  rows.forEach(_ref => {
    let {
      className,
      text
    } = _ref;
    const row = document.createElement('span');
    row.classList.add('block', 'margin-xs-bottom');
    if (className) {
      row.classList.add(...className.split(' '));
    }
    const textNode = document.createTextNode(text);
    row.appendChild(textNode);
    paragraph.appendChild(row);
  });
  return paragraph;
};
function getPeppbubbles(result) {
  switch (result.productId) {
    case 'EUROJACKPOT':
      return getPeppbubblesEurojackpot(result);
    case 'KENO':
      return getPeppbubblesKeno(result);
    case 'LOTTO':
      return getPeppbubblesLotto(result);
    case 'VIKINGLOTTO':
      return getPeppbubblesVikinglotto(result);
    default:
  }
}
function getPeppbubblesEurojackpot(_ref2) {
  let {
    winningCountry,
    payout,
    jackpot
  } = _ref2;
  const distribution = payout.distribution;
  let bubble1;
  if (winningCountry) {
    bubble1 = createBubble([{
      text: winningCountry,
      className: 'f-700 f-medium'
    }]);
  } else {
    bubble1 = getWinsAtWinlevel(distribution, 2, 4);
  }
  if (!bubble1) {
    bubble1 = getRandomInternational(distribution, 'Eurojackpot');
  }
  const bubble2 = getInternationalJackpotBubble(jackpot);
  return [bubble1, bubble2];
}
function getPeppbubblesVikinglotto(_ref3) {
  let {
    winningCountries,
    payout,
    jackpot
  } = _ref3;
  const [{
    countries
  }] = winningCountries;
  const distribution = payout.distribution;
  let bubble1;
  if (countries.length) {
    let jackpotText = 'Jackpot gick till ';
    for (let i = 0, len = countries.length; i < len; i++) {
      if (i) jackpotText += ', ';
      jackpotText += countries[i].country;
    }
    bubble1 = createBubble([{
      text: jackpotText,
      className: 'f-700 f-medium'
    }]);
  } else {
    bubble1 = getWinsAtWinlevel(distribution, 2, 2);
  }
  if (!bubble1) bubble1 = getRandomInternational(distribution, 'Vikinglotto');
  const bubble2 = getInternationalJackpotBubble(jackpot);
  return [bubble1, bubble2];
}
function getPeppbubblesKeno(_ref4) {
  let {
    topWin,
    totalWinners,
    totalPayout
  } = _ref4;
  let bubble1, bubble2;
  const standardBubble1 = [{
      text: 'Totalt antal vinster'
    }, {
      text: "".concat(formatNum(totalWinners), " st"),
      className: 'f-700 f-medium'
    }],
    standardBubble2 = [{
      text: 'Totalt utbetalt vinstbelopp'
    }, {
      text: "".concat(formatNum(parseInt(totalPayout, 10)), " kr"),
      className: 'f-700 f-medium'
    }];
  const topWinAmount = parseInt(topWin.amount, 10);
  if (topWinAmount >= 20000) {
    bubble1 = [{
      text: 'Högst vinst idag'
    }, {
      text: "".concat(formatNum(topWinAmount), " kr"),
      className: 'f-700 f-medium'
    }, {
      text: "".concat(formatNum(topWin.winners), " vinnare p\xE5 ").concat(topWin.description)
    }];
    switch (Math.floor(Math.random() * 2)) {
      case 0:
        bubble2 = standardBubble1;
        break;
      case 1:
        bubble2 = standardBubble2;
        break;
      default:
    }
  }
  return [createBubble(bubble1 || standardBubble1), createBubble(bubble2 || standardBubble2)];
}
function getPeppbubblesLotto(_ref5) {
  let {
    lotto1,
    lotto2,
    joker,
    productDrawId,
    drawNumber,
    jackpot
  } = _ref5;
  const lotto1Payout = lotto1.payout;
  const lotto2Payout = lotto2.payout;
  const dromvinstPayout = lotto1Payout.dromvinstPayout || lotto2Payout.dromvinstPayout;
  let {
    jackpotAmountString
  } = jackpot;
  const dromvinstCloud = new Image();
  dromvinstCloud.src = "".concat(svs.core.config.data.svsconfig.cdn, "/images/numbergames/andra-chansen-banners/dromvinstmolnet.png");
  dromvinstCloud.alt = 'Drömvinsten';
  dromvinstCloud.classList.add('image-dromvinsten-cloud');
  let bubble1 = getMillionRainBubble(lotto1Payout.millionRain, lotto2Payout.millionRain, dromvinstPayout, productDrawId, drawNumber);
  if (!bubble1) {
    const distributions = [lotto1Payout.distribution, lotto2Payout.distribution];
    if (lotto1Payout.dromvinstPayout) {
      distributions.push([lotto1Payout.dromvinstPayout]);
    }
    if (lotto2Payout.dromvinstPayout) {
      distributions.push([lotto2Payout.dromvinstPayout]);
    }
    let payoutProduct = 'Lotto';
    if (joker) {
      distributions.push(joker.payout.distribution);
      payoutProduct += ' och Joker';
    }
    switch (Math.floor(Math.random() * 2)) {
      case 0:
        bubble1 = createBubble([{
          text: 'Totalt',
          className: 'f-500'
        }, {
          text: formatNum(distributions.reduce((total, dist) => total + getTotalWinners(dist), 0)),
          className: 'f-700 f-medium'
        }, {
          text: "vinster p\xE5 ".concat(payoutProduct, " denna g\xE5ng!")
        }]);
        break;
      case 1:
        bubble1 = createBubble([{
          text: 'Totalt',
          className: 'f-500'
        }, {
          text: "".concat(formatNum(distributions.reduce((total, dist) => total + getTotalPayout(dist), 0)), " kr"),
          className: 'f-700 f-medium'
        }, {
          text: "har betalats ut i vinster p\xE5 ".concat(payoutProduct, " denna g\xE5ng!"),
          className: 'f-500'
        }]);
        break;
      default:
    }
  }
  const texts = [];
  if (!dromvinstPayout) {
    texts.push({
      text: 'Ingen Drömvinst denna dragning.'
    });
  }
  jackpotAmountString = jackpotAmountString.replace('alltid minst ', '');
  jackpotAmountString = jackpotAmountString.replace('ca ', '');
  texts.push({
    text: "Dr\xF6mvinsten alltid ".concat(jackpotAmountString),
    className: 'f-700 f-medium'
  });
  const bubble2 = createBubble(texts);
  return [bubble1, dromvinstCloud, bubble2];
}
function getMillionRainBubble(lotto1MillionRain, lotto2MillionRain, dromvinstPayout) {
  const lotto1Dist = lotto1MillionRain && lotto1MillionRain.distribution || [];
  const lotto2Dist = lotto2MillionRain && lotto2MillionRain.distribution || [];
  const millionRain = [...lotto1Dist, ...lotto2Dist];
  let totalMillionWinners = 0;
  if (millionRain.length) {
    totalMillionWinners = millionRain.reduce((totalMillionWinners, currentPayout) => totalMillionWinners + (currentPayout && currentPayout.winners || 0), 0);
  }
  if (totalMillionWinners) {
    const rows = [{
      text: 'Drömvinsten gick ut!'
    }, {
      text: "".concat(dromvinstPayout.amount, " kr"),
      className: 'f-700 f-medium'
    }, {
      text: 'Miljonregnet skapade',
      className: 'f-200 margin-top-half'
    }, {
      text: "".concat(totalMillionWinners, " vinster"),
      className: 'f-700 f-medium'
    }, {
      text: "p\xE5 ".concat(lotto1MillionRain && lotto2MillionRain ? 'Lotto 1 & 2' : lotto1MillionRain ? 'Lotto 1' : 'Lotto 2'),
      className: 'f-200'
    }];
    return createBubble(rows);
  }
}
function getTotalWinners() {
  let distribution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return distribution.reduce((total, dist) => isNaN(dist.winners) ? total : total + dist.winners, 0);
}
function getTotalPayout() {
  let distribution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return distribution.reduce((total, dist) => {
    const amount = parseInt(dist.amount, 10) * dist.winners;
    return isNaN(amount) ? total : total + amount;
  }, 0);
}
function getWinsAtWinlevel(distribution, start, end) {
  for (let i = start - 1; i < end; i++) {
    const winLevel = distribution[i];
    if (winLevel.winners) {
      return createBubble([{
        text: "".concat(winLevel.winners, " vinnare i Sverige vann")
      }, {
        text: "".concat(formatNum(parseInt(winLevel.amount, 10)), " kr"),
        className: 'f-700 f-medium'
      }, {
        text: "".concat(winLevel.winners > 1 ? ' vardera.' : '', " Grattis!")
      }]);
    }
  }
}
function getRandomInternational(distribution, product) {
  let max;
  switch (product) {
    case 'Vikinglotto':
      max = 2;
      break;
    case 'Eurojackpot':
      max = 3;
      break;
    default:
      return;
  }
  let rows;
  switch (Math.floor(Math.random() * max)) {
    case 0:
      rows = [{
        text: 'Totalt'
      }, {
        text: formatNum(getTotalWinners(distribution)),
        className: 'f-700 f-medium'
      }, {
        text: "vinster i Sverige p\xE5 ".concat(product, " denna vecka!")
      }];
      break;
    case 1:
      rows = [{
        text: 'Denna vecka betalades totalt'
      }, {
        text: "".concat(formatNum(getTotalPayout(distribution)), " kr"),
        className: 'f-700 f-medium'
      }, {
        text: "ut i vinster p\xE5 ".concat(product, " i Sverige!")
      }];
      break;
    case 2:
      rows = [{
        text: 'Totalt'
      }, {
        text: formatNum(getTotalInternationalWinners(distribution)),
        className: 'f-700 f-medium'
      }, {
        text: "spelare vann p\xE5 ".concat(product, " denna vecka!")
      }];
      break;
    default:
  }
  if (rows) {
    return createBubble(rows);
  }
}
function getTotalInternationalWinners() {
  let distribution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return distribution.reduce((total, dist) => {
    const winners = dist.winners + dist.iWinners;
    return isNaN(winners) ? total : total + winners;
  }, 0);
}
function getInternationalJackpotBubble() {
  let jackpot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    defaultJackpot,
    jackpotAmountString
  } = jackpot;
  if (defaultJackpot) {
    return createBubble([{
      text: 'Jackpot'
    }, {
      text: jackpotAmountString,
      className: 'f-700 f-medium'
    }]);
  }
  return createBubble([{
    text: 'Jackpot nu uppe i'
  }, {
    text: jackpotAmountString,
    className: 'f-700 f-medium'
  }]);
}

function formatNum(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
}
svs.numbergames.results_common.helpers.peppbubbles = {
  getPeppbubbles
};

 })(window);